<template>
  <div>
    <van-nav-bar
      title="产品绑定"
      :left-text="'您好，' + userInfo.emp_name"
    />
    <van-form ref="form" validate-first>
      <van-col :span="24">
        <base-input-number v-model="form.start_id" label="起始身份号" required
                           @blur="onStartOrEndIdBlur($event, 'start_id')">
          <template #button>
            <base-button @click="scanQRCode('start_id')">扫码</base-button>
          </template>
        </base-input-number>
      </van-col>
      <van-col :span="24">
        <base-input-number v-model="form.end_id" label="结束身份号" required
                           @blur="onStartOrEndIdBlur($event, 'end_id')">
          <template #button>
            <base-button @click="scanQRCode('end_id')">扫码</base-button>
          </template>
        </base-input-number>
      </van-col>
      <van-col :span="20" :offset="2">
        <br>
        <base-button size="large" :round="true" @click="confirm">确认</base-button>
      </van-col>
    </van-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { wxJsConfig } from '@/api/commons'
export default {
  name: 'TrackBind',
  data() {
    return {
      form: {
        start_id: null,
        end_id: null
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  async mounted() {
    const config = {
      timestamp: Date.now(),
      nonceStr: 'esap',
      jsurl: window.location.href,
      jsapp: this.CONST.AGENT_MAP[this.$route.path]
    }
    const resp = await wxJsConfig(config)
    if (resp.obj && resp.obj.appId && resp.obj.signature) {
      wx.config({
        beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: resp.obj.appId, // 必填，企业微信的corpID
        timestamp: config.timestamp, // 必填，生成签名的时间戳
        nonceStr: config.nonceStr, // 必填，生成签名的随机串
        signature: resp.obj.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
        jsApiList: ['scanQRCode'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
      })
      wx.ready(() => {
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
      })
      wx.error(res => {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        console.error(res)
        this.hasError = true
        this.errorMsg = '初始化企业微信接口错误'
        this.alert(this.errorMsg)
      })
    } else {
      this.hasError = true
      this.errorMsg = '初始化企业微信接口错误'
      this.alert(this.errorMsg)
    }
  },
  methods: {
    onStartOrEndIdBlur(val, attr) {
      if (attr === 'start_id' && !this.form.end_id) {
        this.form.end_id = val
      } else if (attr === 'end_id' && !this.form.start_id) {
        this.form.start_id = val
      }
    },
    scanQRCode(attr) {
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['barCode'], // 可以指定扫二维码还是一维码，默认二者都有 barCode
        success: (resp) => {
          if (resp.err_Info === 'success') {
            const id = String(resp.resultStr || '')
            if (id) {
              this.form[attr] = id
              if (attr === 'start_id' && !this.form.end_id) {
                this.form.end_id = id
              } else if (attr === 'end_id' && !this.form.start_id) {
                this.form.start_id = id
              }
            } else {
              this.toast('一维码信息读取错误，请扫描正确的一维码')
            }
          }
        }
      })
      // 扫描二维码模式
      // wx.scanQRCode({
      //   needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      //   scanType: ['qrCode'], // 可以指定扫二维码还是一维码，默认二者都有 barCode
      //   success: (resp) => {
      //     if (resp.err_Info === 'success') {
      //       const resultStr = String(resp.resultStr || '')
      //       if (resultStr.includes('id=')) {
      //         const id = resultStr.substring(resultStr.indexOf('id=') + 3, resultStr.indexOf('&'))
      //         this.form[attr] = id
      //         if (attr === 'start_id' && !this.form.end_id) {
      //           this.form.end_id = id
      //         } else if (attr === 'end_id' && !this.form.start_id) {
      //           this.form.start_id = id
      //         }
      //       } else {
      //         this.toast('二维码信息读取错误，请扫描正确的二维码')
      //       }
      //     }
      //   }
      // })
    },
    confirm() {
      this.$refs['form'].validate().then(_ => {
        localStorage.setItem('trackBindForm', JSON.stringify(this.form))
        this.$router.push('/bind-produce/order-manage')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/bind-produce/track-bind.vue